const _ = require("lodash");
class LoanTermCalculator {

    /**
     * 
     * @param rate
     * @param principal
     * @param monthlyPayment
     */
    constructor(rate, principal, monthlyPayment) {
        this.rate = rate;
        this.principal = principal;
        this.monthlyPayment = monthlyPayment;
    }

    calculateLoanTerms() {
        let months = 0;
        let rte = this.rate / 1200;
        let pmt = this.monthlyPayment;
        let amt = this.principal;
        months = (Math.log(1 + (rte / (pmt / (amt) - rte))) / Math.log(1 + rte));
        months = months * 1000;
        months = Math.round(months);
        months = months / 1000;
        return Math.round(months);
    }
}

module.exports = LoanTermCalculator;
